import React from 'react';

const ProjectIssueDetailRow = ({ label, description }) => {
    return (
        <tr>
            <td>
                <div className="user-profile d-flex flex-row align-items-center">
                    <div className="user-detail">
                        <h5 className="user-name">{label} </h5>
                    </div>
                </div>
            </td>
            <td className="text-right">
                <div>{description}</div>
            </td>
        </tr>

    );
};


export default ProjectIssueDetailRow;



// WEBPACK FOOTER //
// ./components/Agile/projectIssue/projectIssueDetail/projectIssueDetailRow/index.js